const INITIAL_STATE = {
  articles: [],
  isButtonSendClicked: false,
}

const articlesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "LOAD_ARTICLES": {
      return {
        ...state,
        articles: action.payload
      };
    }
    case "BUTTON_SEND_CLICKED": {
      return {
        ...state,
        isButtonSendClicked: true,
      };
    }
    case "ADD_ARTICLE": {
      const updateArticles = [...state.articles];
      updateArticles.unshift(action.payload);
      return {
        ...state,
        articles: [...updateArticles],
        isButtonSendClicked: false,
      };
    }
    default:
      return state;
  }

}

export default articlesReducer;